import api from "../api";

export const masterApi = async (payload) => {
  const response = await api.post("/PMSRoutes/MasterAPI", payload);
  return response.data;
};

export const getUnits = async (orgId) => {
  return masterApi({
    OrgId: orgId,
    Action: "GetUnits",
    JsonData: {},
  });
};

export const getProcedureMasters = async (orgId, unitId) => {
  return masterApi({
    OrgId: orgId,
    Action: "GetProcedureMasters",
    JsonData: {
      UnitId: unitId,
    },
  });
};

export const getUsersByRole = async (orgId, roleId) => {
  return masterApi({
    OrgId: orgId,
    Action: "GetUsersByRole",
    JsonData: {
      RoleId: roleId,
    },
  });
};

export const getAppointmentDetailsById = async (orgId, appointmentId) => {
  return masterApi({
    OrgId: orgId,
    Action: "GetAppointmentDetailsById",
    JsonData: {
      AppointmentId: appointmentId,
    },
  });
};

export const getAppointmentsByPatientId = async (orgId, patientId) => {
  return masterApi({
    OrgId: orgId,
    Action: "GetAppointmentsByPatientId",
    JsonData: {
      PatientId: patientId,
    },
  });
};

export const getAppointmentfiles = async (appointmentId) => {
  return masterApi({
    Action: "GetAppointmentfiles",
    JsonData: {
      AppointmentId: appointmentId,
    },
  });
};

export const getDoctorSlots = async (orgId, doctorId) => {
  return masterApi({
    Action: "GetDoctorSlots",
    OrgId: orgId,
    JsonData: {
      DoctorId: doctorId,
    },
  });
};

export const getDoctorSlotsForDate = async (orgId, doctorId, appointmentDate) => {
  return masterApi({
    Action: "GetDoctorSlotsForDate",
    OrgId: orgId,
    JsonData: {
      DoctorId: doctorId,
      AppointmentDate: appointmentDate,
    },
  });
};

export const getDashboardSummary = async (orgId, doctorId) => {
  return masterApi({
    Action: "DashboardSummary",
    OrgId: orgId,
    JsonData: {
      DoctorId: doctorId,
    },
  });
};

